import React, { createContext, useState, useContext, useEffect } from 'react';
import authService from '../services/authService';
import SessionManager from '../utils/sessionManager';

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [sessionManager, setSessionManager] = useState(null);

  useEffect(() => {
    const user = authService.getCurrentUser();
    setCurrentUser(user);
    
    // Initialize session manager if user is logged in
    if (user) {
      const manager = new SessionManager();
      setSessionManager(manager);
    }
    
    setLoading(false);
  }, []);

  const login = async (username, password) => {
    const response = await authService.login(username, password);
    setCurrentUser(response.data);
    
    // Start session management
    if (sessionManager) {
      sessionManager.destroy();
    }
    const manager = new SessionManager();
    setSessionManager(manager);
    
    return response;
  };

  const register = async (userData) => {
    return await authService.register(userData);
  };

  const logout = () => {
    // Clean up session manager
    if (sessionManager) {
      sessionManager.destroy();
      setSessionManager(null);
    }
    
    authService.logout();
    setCurrentUser(null);
  };

  const value = {
    currentUser,
    login,
    register,
    logout,
    setCurrentUser
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};